export var DisclaimerScrollTarget;
(function (DisclaimerScrollTarget) {
    DisclaimerScrollTarget["CHECKOUT_BASE_FOOTER"] = "checkout:footer:disclaimer:content";
    DisclaimerScrollTarget["FOOTER_DISCLAIMER_SECTION"] = "footer:disclaimerSection";
})(DisclaimerScrollTarget || (DisclaimerScrollTarget = {}));
//# sourceMappingURL=DisclaimerScrollTarget.js.map